export default "__VITE_ASSET__9959eb3d__"